module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "acknowPage"
  }, [_c('a', {
    attrs: {
      "id": "title1"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("ACKNOWLEDGMENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("I wish to thank the people who were so willing to help me in my research for this project. I owe thanks to Sandy Schwan, curator at the Saginaw Historical Museum; Mary Ellen Fike, First Baptist Church historian; the secretaries from Holy Cross, Bethlehem, and St. Paul’s Lutheran Churches; Sally Ippel Haines; and especially to Lorri Lea, Saginaw News Library/Information Specialist, who was always happy to return my many phone calls and to share historical information relating to the people and places pictured on my cards. Also, I am indebted to Patricia Stoppelworth, who shared the collection of her late father, William Culver, and to George Barrett and Herman Rindhage, who graciously shared cards from their own collections for use in this book.")])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "74%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439631416_i0003.jpg",
      "src": "images/e9781439631416_i0003.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("SEMI-CENTENNIAL.")]), _vm._v(" Many cards were sent to friends inviting them to Saginaw for the 50th year celebration in August of 1907. A young woman sent the card on August 9, 1907, inviting her friend to come to the city “as we have excursion rates.” The card indicated “Railroad Excursions from Everywhere.” Another part of the celebration was a Floral Day Parade which moved from the Tower Block on Genesee west to Washington Avenue where it turned past the Bancroft House.")])]), _vm._v(" "), _c('p', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("A complete Semi-Centennial souvenir booklet was printed under the auspices of the Board of Trade showcasing Saginaw’s 50 years from 1857–1907. It contained a history of the city, articles on the current government, pictures of important buildings, pages showing residences of prominent citizens, and descriptions of the churches, schools, parks, and hospitals of the time.")])])])])])]), _c('a', {
    attrs: {
      "id": "title1"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5707ee40","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781439631416_ack01.vue
// module id = 72
// module chunks = 0